import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const fetchRoles = async ({queryKey}) => {
  const {access_token, token_type} = queryKey[1]
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/roles/`,
    method: "POST",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }

  // console.log('resoponse from Organisations RQ', response);
  return response.data;
}
